import React, { Component } from 'react'
import { ISelectSimpleOption, ISelectWithApiOption, ISelectWithApiParams } from '@lib/Forms/Inputs'
import { DinoForm, FormValidator, SingleRuleValidate } from '@lib/Forms'

interface IFormWithDriveData {
  UserId: string
  Categories: string
  ResourceId: string
}

interface IParams {
  options?: ISelectSimpleOption[]
  fetchData?: ISelectWithApiParams<ISelectWithApiOption>['fetchData']
}

const GetFormInstance = (params: IParams) => {
  return DinoForm.createFormGridLayout<IFormWithDriveData>({
    configs: [
      { key: 'UserId', label: 'User', inputElement: DinoForm.createSelectWithApi({ fetchData: params.fetchData }) },
      { key: 'Categories', label: 'Categories', inputElement: DinoForm.createSelectSimple({ options: params.options }) },
      { key: 'ResourceId', label: 'Google Drive Folder ID', inputElement: DinoForm.createInputText({ options: { pastenable: true } }) }
    ],
    validate: new FormValidator({
      UserId: { Rules: [{ rule: SingleRuleValidate.Required }] },
      Categories: { Rules: [{ rule: SingleRuleValidate.Required }] }
    })
  })
}

interface IProps {
  options?: IParams['options']
  onSubmit: (value: Partial<IFormWithDriveData>) => Promise<void>
}

class FormUploadWithDrive extends Component<IProps> {
  FormInstance
  constructor(props: IProps) {
    super(props)
    this.FormInstance = GetFormInstance({ options: props.options })
  }

  render() {
    const { FormInstance } = this
    return (
      <DinoForm.ModalWrap title='Upload with drive' size='md'>
        <FormInstance onSubmit={this.props.onSubmit} />
      </DinoForm.ModalWrap>
    )
  }
}

export default FormUploadWithDrive
